import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin } from '../../../components/molecues';
import { LoadingView } from '../../../../common/components/atoms';

class TopAdmin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        }
    }
    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.dispatch({
            type: "GetCourseInfo_Saga",
        });
    }
    onClickUserCtrl = (e) => {
        this.props.history.push('/admin/user');
    }
    onClickNoticeCtrl = (e) => {
        this.props.history.push('/admin/notice');
    }
    onClickRecordCtrl = (e) => {
        this.props.history.push('/admin/record');
    }
    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight-64) + "px";
        const propsHeader = {
            title: "管理者メニュー",
            history: this.props.history,
        }
        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <Contents Width={width} Height={height}>
                    <Button onClick={this.onClickUserCtrl}>
                        <i className="fas fa-users fa-5x" />
                        ユーザー管理
                    </Button>
                    <Button onClick={this.onClickNoticeCtrl}>
                        <i className="fas fa-comment-dots fa-5x" />
                        お知らせ管理
                    </Button>
                    <Button onClick={this.onClickRecordCtrl}>
                        <i className="fas fa-microphone fa-5x" />
                        録音データ管理
                    </Button>
                </Contents>
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
    }
};

const connectedTopAdmin = connect(mapStateToProps)(TopAdmin);
export { connectedTopAdmin as TopAdmin };

const Body = styled.div`
`;
const Contents = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: auto;
    width: 50%;
    height: ${props => (props.Height)};
`;

const Button = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 16px;
    color: #888;
    transition-duration: 0.2s;
    cursor: pointer;
    i {
        margin-bottom: 10px;
    }
    :hover {
        color: #000;
    }
`;
